<template>
   <div class="container-wrapper" v-loading="loading">
      <div class="breadcrumb-wrapper">
         <span>短信任务</span>
         <span v-if="edit === false"> / 创建</span>
         <span v-if="edit !== false"> / 编辑</span>
         <el-button class="back" type="primary" @click="$router.go(-1)">返回</el-button>
      </div>

      <div class="form-wrapper">
         <el-form ref="formRef" label-width="126px" label-position="left" :rules="rules" :model="formData">
            <el-form-item label="当前人数：">
               <span style="font-weight: bold;">{{ maxCount }}</span>
            </el-form-item>
            <el-form-item label="名称：" prop="name">
               <div class="flex-row">
                  <el-input v-model="formData.name" placeholder="请输入任务名称"></el-input>
               </div>
            </el-form-item>
            <el-form-item label="入学年份：" prop="caid">
               <el-select placeholder="请选择入学年份" v-model="formData.caid" multiple>
                  <el-option v-for="(item, index) in inYearDataSource" :key="index" :label="item.label"
                     :value="item.value"></el-option>
               </el-select>
            </el-form-item>
            <el-form-item label="性别标签：" prop="gender">
               <el-checkbox-group v-model="formData.gender">
                  <el-checkbox label="1">男</el-checkbox>
                  <el-checkbox label="0">女</el-checkbox>
               </el-checkbox-group>
            </el-form-item>
            <el-form-item label="省份标签：" prop="provinces">
               <el-select class="multiple-select" placeholder="请选择省份" v-model="formData.provinces" filterable multiple
                  @change="handleProvinceChange">
                  <el-option label="全部" :value="-1"></el-option>
                  <el-option v-for="(item, index) in provinceList" :key="index" :label="item.label" :value="item.value"
                     :disabled="formData.provinces && formData.provinces.includes(-1)">
                  </el-option>
               </el-select>
            </el-form-item>
            <el-form-item label="选择人数" prop="sendCount">
               <div class="flex-row gap-20">
                  <el-input placeholder="请输入人数" v-model="formData.sendCount" @input="handleSendCountInput"></el-input>
                  <el-button type="primary" @click="getMaxCount">查询人数</el-button>
               </div>
            </el-form-item>
            <el-form-item label="编辑短信：" prop="editMessage">
               <el-input placeholder="请输入短信内容" type="textarea" :autosize="{ minRows: 5 }" :maxlength="1000"
                  v-model="formData.editMessage">
               </el-input>
            </el-form-item>
         </el-form>

         <div class="margin-20">
            <el-button type="primary" @click="clickSave()">保存</el-button>
         </div>
      </div>
   </div>
</template>

<script>
import { provinceListConst } from "../../../../common/constant.js";

export default {
   data() {
      const validateGender = (rule, value, callback) => {
         if (!this.formData.gender || this.formData.gender.length === 0) {
            return callback(new Error("请选择性别标签"));
         }
         callback();
      };
      const validateSendCount = (rule, value, callback) => {
         if (this.formData.sendCount <= 0) {
            return callback(new Error("请输入正确的发送人数"));
         }
         if (this.formData.sendCount > this.maxCount) {
            return callback(new Error("超出当前人数"));
         }
         callback();
      };
      return {
         loading: false,
         id: "",
         edit: false,
         formData: {
            name: "",
            caid: [],
            gender: [],
            provinces: [],
            sendCount: 0,
            editMessage: '',
         },
         maxCount: 0,  // 最大发送人数
         rules: {
            name: [{ required: true, message: "请输入任务名称", trigger: "change" }],
            caid: [{ type: 'array', required: true, message: "请选择入学年份", trigger: "blur", }],
            gender: [{ type: 'array', required: true, validator: validateGender, trigger: "change" }],
            provinces: [{ type: "array", required: true, message: "请选择省份", trigger: "blur", }],
            sendCount: [{ required: true, validator: validateSendCount, trigger: "blur" }],
            editMessage: [{ required: true, message: "请输入短信内容", trigger: "blur" }],
         },
         inYearDataSource: [],
         provinceList: [],
      }
   },

   mounted() {
      const row = this.$util.getStore("smsTaskRow");
      if (row && row != '{}') {
         this.$util.removeStore("smsTaskRow");
         this.configDetail(JSON.parse(row));
         this.edit = true;
      }

      // 获取入学年份
      const thisYear = new Date().getFullYear();
      for (let i = 0; i < 10; i++) {
         this.inYearDataSource.push({
            label: thisYear - i,
            value: `${thisYear - i}`,
         });
      }

      this.provinceList = provinceListConst;
   },

   methods: {
      // 配置详情
      configDetail(row) {
         this.id = row.id;
         this.formData.name = row.taskName;
         this.formData.provinces = row.provinces ? row.provinces.split(',') : [-1];
         this.formData.caid = row.caid ? row.caid.split(',') : [];
         this.formData.gender = row.gender ? row.gender.split(',') : [];
         this.formData.sendCount = row.sendCount;
         this.formData.editMessage = row.content.replace(/【运动世界校园】/, '');

         // 计算最大发送人数
         this.getMaxCount();
      },

      // 获取最大发送人数
      async getMaxCount() {
         if (!this.formData.caid.length === 0) {
            this.$message.error("请选择入学年份");
            return;
         }
         if (this.formData.gender.length === 0) {
            this.$message.error("请选择性别标签");
            return;
         }
         if (this.formData.provinces.length === 0) {
            this.$message.error("请选择省份");
            return;
         }
         this.loading = true;
         try {
            const res = await this.$http({
               url: this.$util.domain + '/adminapi/v61200/sms/task/max',
               method: 'POST',
               body: JSON.stringify({
                  provinces: this.formData.provinces.includes(-1) ? undefined : this.formData.provinces.join(','),
                  caid: this.formData.caid.join(','),
                  gender: this.formData.gender.join(','),
               })
            });

            if (res.data.error === 10000) {
               this.maxCount = res.data.data;
            }
         } catch (err) {
            this.$message.error('获取最大发送人数失败');
         } finally {
            this.loading = false;
         }
      },

      // 发送添加信息 
      sendAdditionInfo() {
         this.loading = true;
         this.$http({
            url: this.$util.domain + '/adminapi/v61200/sms/task/add',
            method: 'POST',
            body: JSON.stringify({
               name: this.formData.name,
               provinces: this.formData.provinces.includes(-1) ? undefined : this.formData.provinces.join(','),
               caid: this.formData.caid.join(','),
               gender: this.formData.gender.join(','),
               sendCount: this.formData.sendCount,
               editMessage: "【运动世界校园】" + this.formData.editMessage,
            })
         }).then((res) => {
            if (res.data.error === 10000) {
               this.$message.success("保存成功");
               this.$router.go(-1);
            } else {
               this.$message.error(res.msg);
            }
         }).catch((err) => {
            this.$message.error("保存失败");
         }).finally(() => {
            this.loading = false;
         });
      },

      // 发送更新信息
      sendUpdateInfo() {
         this.loading = true;
         this.$http({
            url: this.$util.domain + '/adminapi/v61200/sms/task/update',
            method: 'POST',
            body: JSON.stringify({
               id: this.id || undefined,
               name: this.formData.name,
               provinces: this.formData.provinces.length === this.provinceList.length ? undefined : this.formData.provinces.join(','),
               caid: this.formData.caid.join(','),
               gender: this.formData.gender.join(','),
               sendCount: this.formData.sendCount,
               editMessage: "【运动世界校园】" + this.formData.editMessage,
            })
         }).then((res) => {
            console.log('res: ', res);
            if (res.data.error === 10000) {
               this.$message.success("保存成功");
               this.$router.go(-1);
            } else {
               this.$message.error(res.msg);
            }
         }).catch((err) => {
            this.$message.error("保存失败");
         }).finally(() => {
            this.loading = false;
         });
      },

      // 处理省份选择变化
      handleProvinceChange(val) {
         if (val.includes(-1)) {
            // 防止无限循环
            if (this.formData.provinces.includes(-1) && this.formData.provinces.length === 1) {
               return;
            }
            // 如果选择了"全部"，清空其他选项
            this.formData.provinces = [-1];
         } else if (val.length === this.provinceList.length) {
            // 如果选择了所有省份，自动切换为"全部"
            this.formData.provinces = [-1];
         }
      },

      // 处理发送人数输入
      handleSendCountInput(value) {
         const num = parseInt(value);
         if (isNaN(num) || num < 0) {
            this.$nextTick(() => {
               this.formData.sendCount = 0;
            });
         } else {
            this.$nextTick(() => {
               this.formData.sendCount = num;
            });
         }
      },

      // 保存
      clickSave() {
         this.$refs.formRef.validate((valid) => {
            if (valid) {
               if (this.edit) {
                  this.sendUpdateInfo();
               } else {
                  this.sendAdditionInfo();
               }
            }
         });
      },
   }
}
</script>

<style scoped>
.multiple-select {
   width: 100%;
}
</style>


// WEBPACK FOOTER //
// SMSTaskEdit.vue?515a94c8